import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsPlConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static LEASE_LABEL = "Lease details";
    static DRAW_POLYGON_LABEL = "Please draw an area (polygon) around the lease area on the location tab.";
    static POLYGON_DRAWN_LABEL = "Lease area selected.";
    static LEASE_TYPE_LABEL = "Lease type";
    static LEASE_REASON_LABEL = "Lease reason";
    static LEASE_USE_LABEL = "What will the lease be used for?";
    static LEASE_RENTAL_AGREEMENT_LABEL = "Lease rental agreement amount (p/m)";
    static LEASE_START_DATE_LABEL = "Lease start date";
    static LEASE_END_DATE_FORM_LABEL = "Lease end date";
    static LESSEE_LABEL = "Lessee";
    static SELLER_LABEL = "Seller";
    static BUYER_LABEL = "Buyer";
    static LESSEE_TYPE_LABEL = "Lessee type";
    static ALIENATION_LABEL = "Alienation details";
    static SALE_AMOUNT_LABEL = "Sale amount (R)";
    static DATE_OF_DEED_TRANSFER_LABEL = "Date of deed transfer";
    static EVALUATION_AMOUNT_LABEL = "Evaluation amount (R)";
    static ACQUISITION_LABEL = "Acquisition details";
    static COPY_APPLICANT_TO_LESSEE_LABEL = "Copy applicant to lessee";
    static COPY_APPLICANT_TO_BUYER_LABEL = "Copy applicant to buyer";
    static COPY_APPLICANT_TO_SELLER_LABEL = "Copy applicant to seller";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static TRANSFERRING_ATTORNEY_LABEL = "Transferring attorney";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static LEASE_TYPE_FORM_CONTROL_NAME = "leaseType";
    static LEASE_REASON_FORM_CONTROL_NAME = "leaseReason";
    static LEASE_USE_FORM_CONTROL_NAME = "leaseUse";
    static LEASE_RENTAL_AGREEMENT_FORM_CONTROL_NAME = "leaseRentalAgreementAmount";
    static LEASE_START_DATE_FORM_CONTROL_NAME = "leaseStartDate";
    static LEASE_END_DATE_FORM_CONTROL_NAME = "leaseEndDate";
    static LESSEE_TYPE_FORM_CONTROL_NAME = "lesseeType";
    static LESSEE_FORM_CONTROL_NAME = "lesseeRecipient";
    static SALE_AMOUNT_FORM_CONTROL_NAME = "saleAmount";
    static DATE_OF_DEED_TRANSFER_FORM_CONTROL_NAME = "dateOfDeedTransfer";
    static EVALUATION_AMOUNT_FORM_CONTROL_NAME = "evaluationAmount";
    static BUYER_FORM_CONTROL_NAME = "buyerRecipient";
    static SELLER_FORM_CONTROL_NAME = "sellerRecipient";
    static SALE_AMOUNT_ALIENATION_FORM_CONTROL_NAME = "saleAmountAlienation";
    static DATE_OF_DEED_TRANSFER_ALIENATION_FORM_CONTROL_NAME = "dateOfDeedTransferAlienation";
    static EVALUATION_AMOUNT_ALIENATION_FORM_CONTROL_NAME = "evaluationAmountAlienation";
    static REFERENCE_NUMBER_FORM_CONTROL_NAME = "referenceNumber";
    static TRANSFERRING_ATTORNEY_FORM_CONTROL_NAME = "transferringAttorneyRecipient";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        leaseType: {
            required: `Lease type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        leaseReason: {
            required: `Lease reason ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        leaseUse: {
            required: `Lease use ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        leaseRentalAgreementAmount: {
            required: `Lease rental agreement ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        leaseStartDate: {
            required: `Lease start date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        leaseEndDate: {
            required: `Lease end date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        lesseeType: {
            required: `Lessee type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        saleAmount: {
            required: `Sale amount ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        dateofDeedTransfer: {
            required: `Date of deed transfer ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        evaluationAmount: {
            required: `Evaluation amount ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        referenceNumber: {
            required: `Reference ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
